export default __webpack_public_path__ + "static/media/green-award-check.1fd4a94e.svg";